import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { translateData } from 'utils/translation';
import { dataLayerPush } from 'utils/tracking';
import { H1, P, H2, Div } from 'components/Ui';

import styles from './styles.scss';

const logError = (error) => {
  const { code, message } = error;
  dataLayerPush(
    'Acquisition, SelfServe',
    {
      event: 'showError',
      type: code,
      message,
      session_id: window?.DD_RUM?.getInternalContext().session_id,
      payload: error,
    },
    'dlE1',
  );
};

const WorkInProgress = () => {
  const error = window?.showSomethingWentWrongError;

  logError(error);

  return (
    <Fragment>
      <Helmet title={translateData('WorkInProgress:Title')} />
      <div className={styles.container}>
        <H1>WorkInProgress:Title</H1>
        <P>WorkInProgress:Description</P>
        <ul className="water-regional_list water-regional_dark water-regional_water-contact-us-content">
          <li className="water-regional_listItem water-regional_dark water-regional_water-contact-us-content">
            <H2 className="water-regional_title water-regional_dark water-regional_water-contact-us-content">
              WorkInProgress:Callus
            </H2>
            <h3 className="water-regional_title water-regional_dark water-regional_water-contact-us-content">
              {/* FIXME: The phone number should be parameterized. */}
              <a
                href={`tel:${translateData('WorkInProgress:CallusNumber')}`}
                target="_blank"
                title="Call us"
              >
                {translateData('WorkInProgress:CallusNumber')}
              </a>
            </h3>
            <div className="water-regional_subtitle water-regional_dark water-regional_water-contact-us-content">
              {/* FIXME: The hours and days should be parameterized. */}
              <Div>WorkInProgress:CallusDescription</Div>
            </div>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

export default connect()(WorkInProgress);
